/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_EsppEnrollmentRowDto } from '../models/PagedResultDto_EsppEnrollmentRowDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppEnrollmentService {

    /**
     * @param offeringPeriodId
     * @param purchasePeriodId
     * @param formData
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardOfferingPeriodPurchasePeriodEnrollmentImport(
        offeringPeriodId: string,
        purchasePeriodId: string,
        formData?: {
            File?: Blob;
        },
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/enrollment/import',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param purchasePeriodId
     * @param enrollmentStatus
     * @param esppParticipantId
     * @param autoEnrollments
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_EsppEnrollmentRowDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriodEnrollment(
        offeringPeriodId: string,
        purchasePeriodId: string,
        enrollmentStatus?: Array<string>,
        esppParticipantId?: string,
        autoEnrollments?: boolean,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_EsppEnrollmentRowDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/enrollment',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            query: {
                'EnrollmentStatus': enrollmentStatus,
                'EsppParticipantId': esppParticipantId,
                'AutoEnrollments': autoEnrollments,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param purchasePeriodId
     * @param enrollmentStatus
     * @param esppParticipantId
     * @param autoEnrollments
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriodEnrollmentExport(
        offeringPeriodId: string,
        purchasePeriodId: string,
        enrollmentStatus?: Array<string>,
        esppParticipantId?: string,
        autoEnrollments?: boolean,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/enrollment/export',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            query: {
                'EnrollmentStatus': enrollmentStatus,
                'EsppParticipantId': esppParticipantId,
                'AutoEnrollments': autoEnrollments,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodImportSamplesEnrollment(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/import-samples/enrollment',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
